import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map, isFunction as _isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import AddOnsCard from '../AddOnsCard';

import styles from './AddOnsList.Styles';

function onAddOnCardPress(onAddOnPress, addon, index) {
  if (_isFunction(onAddOnPress)) {
    onAddOnPress(addon, index);
  }
}

function AddOnsList({
  isBuyAddOns,
  withUsers,
  title,
  data,
  onAddOnPress,
  containerStyle,
  itemStyle,
  images,
  isCurrencyFirst,
  isExpired,
  ...props
}) {
  return (
    <View style={containerStyle}>
      {title && <VFText i18nKey={title} style={styles.titleStyle} />}

      {_map(data, (addon, index) => {
        return (
          <AddOnsCard
            withUsers={withUsers}
            key={addon?.id || index}
            item={addon}
            onPress={() => onAddOnCardPress(onAddOnPress, addon, index)}
            style={itemStyle}
            images={images}
            isCurrencyFirst={isCurrencyFirst}
            isExpired={isExpired}
          />
        );
      })}
    </View>
  );
}

const addonPropType = PropTypes.shape({
  users: PropTypes.array,
  id: PropTypes.string,
  status: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  price: PropTypes.shape({
    type: PropTypes.string,
    recurringPeriod: PropTypes.string,
    unitOfMeasure: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currency: PropTypes.string,
  }),
  validFor: PropTypes.shape({
    endDate: PropTypes.any,
    startDate: PropTypes.any,
  }),
  icon: PropTypes.any,
  image: PropTypes.any,
});

AddOnsList.defaultProps = {
  isBuyAddOns: false,
  isCurrencyFirst: false,
};

AddOnsList.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(addonPropType),
  onAddOnPress: PropTypes.func,
  isBuyAddOns: PropTypes.bool,
  containerStyle: ViewPropTypes.style,
  itemStyle: ViewPropTypes.style,
  images: PropTypes.object,
  withUsers: PropTypes.bool,
  isCurrencyFirst: PropTypes.bool,
  isExpired: PropTypes.bool,
};

export { addonPropType };
export default AddOnsList;
